module.exports = __webpack_public_path__ + "e8965725c7ae97d436d241f6713328f8.MP3";